/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type DomainTeamDto = {
    id: string;
    name: string;
    role: DomainTeamDto.role;
};

export namespace DomainTeamDto {

    export enum role {
        EDITOR = 'Editor',
        MONITOR_RESPONDER = 'Monitor responder',
        CATALOG_EDITOR = 'Catalog editor',
        VIEWER = 'Viewer',
    }


}
